import { makeStyles } from '@material-ui/core/styles';
import { headerHeight } from 'config';
import { Theme } from 'enum';

export const useStyles = makeStyles((theme) => {
    return {
        appBar: {
            backgroundColor: theme.palette.type === Theme.Light ? '#fff' : '#282828',
            height: headerHeight,
            boxShadow: 'none',
            transition: '.5s box-shadow',
        },
        shadow: {
            boxShadow: '0 0 6px 0 rgba(0,0,0,.12)',
        },
        logoContainer: {
            marginTop: '3px',
            marginRight: theme.spacing(1.5),
        },
        icon: {
            color: theme.palette.text.secondary,
            transition: '.3s',
            '& svg': {
                fill: theme.palette.text.secondary,
                transition: '.3s',
            },
            '&:hover': {
                color: theme.palette.text.primary,
                '& svg': {
                    fill: theme.palette.text.primary,
                },
            },
        },
        loginButton: {
            borderRadius: 50,
            width: 100,
            textTransform: 'none',
            marginLeft: theme.spacing(1),
            boxShadow: 'none',
            fontWeight: 'bolder',
        },
        toolbar: {
            height: '100%',
            padding: 0,
        },
        menu: {
            height: '100%',
            display: 'flex',
            flexGrow: 1,
            paddingLeft: theme.spacing(2),
        },
        menuItem: {
            display: 'flex',
            color: theme.palette.text.secondary,
            transition: '.3s',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(0, 2),
            '&:hover': {
                color: theme.palette.primary.main,
            },
        },
    };
});
